import EmployeeActivityLog from "../Components/EmployeeActivityLog";
import EmployeeInfoTopSection from "../Components/EmployeeInfoTopSection";
import AddEditEmployee from "../Components/Dialogs/AddEditEmployee";
import Delete from "../Components/Dialogs/Delete";
import { useParams } from "react-router-dom";
import useEmployees from "../hooks/useEmployees";
import { CircularProgress, Box } from "@mui/material";

const EmployeeInfo = () => {
  const { employeeId } = useParams();
  const {
    employeeById,
    employeeByIdLoading,
    employeeByIdError,
    deleteEmployeeLoading,
    handleDeleteEmployee,
  } = useEmployees({
    employeeId: employeeId,
  });

  // Show loading state
  if (employeeByIdLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <CircularProgress />
          <p className="text-gray-600">Loading employee information...</p>
        </Box>
      </div>
    );
  }

  // Show error state
  if (employeeByIdError) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-4">⚠️</div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Failed to Load Employee Data
          </h3>
          <p className="text-gray-600">
            Unable to load employee information. Please try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Check if employee data exists
  if (!employeeById?.data) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="text-center">
          <div className="text-gray-400 text-xl mb-4">👤</div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">
            Employee Not Found
          </h3>
          <p className="text-gray-600">
            The employee you're looking for doesn't exist or has been removed.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <EmployeeInfoTopSection employeeData={employeeById.data} />
      <EmployeeActivityLog />
      <AddEditEmployee />
      <Delete
        title="Delete Employee"
        subTitle="Are you sure you want to delete this employee?"
        loading={deleteEmployeeLoading}
        fun={handleDeleteEmployee}
      />
    </div>
  );
};

export default EmployeeInfo;
